const AUTH_TOKEN = 'auth-token';
const ROLE_ID = 'role_id';
const USER_ID = 'user_id';
const AUTH_ID = localStorage.getItem('user_id');
export {AUTH_TOKEN, ROLE_ID, USER_ID, AUTH_ID};
